import type { Attributes, HeadElement } from '@xing-com/crate-xinglet/internal';

export type HelmetState = {
  defaultTitle: string | undefined;
  title: string | undefined;
  titleTemplate: string | undefined;
  htmlAttributes: Attributes;
  bodyAttributes: Attributes;
  elements: Map<string, HeadElement>;
};

function stringifyElement({ kind, attributes, ...rest }: HeadElement): string {
  const keys = Object.keys(attributes).toSorted();
  return JSON.stringify({
    kind,
    attributes: Object.fromEntries(keys.map((key) => [key, attributes[key]])),
    ...rest,
  });
}

export function mergeState(elements: HeadElement[]): HelmetState {
  const state: HelmetState = {
    defaultTitle: 'XING',
    title: undefined,
    titleTemplate: undefined,
    htmlAttributes: {},
    bodyAttributes: {},
    elements: new Map(),
  };

  for (const { kind, attributes, content } of elements) {
    switch (kind) {
      case 'title': {
        const { titleTemplate } = attributes;
        if (content) state.title = content;
        if (titleTemplate) state.titleTemplate = titleTemplate;
        break;
      }
      case 'html': {
        Object.assign(state.htmlAttributes, attributes);
        break;
      }
      case 'body': {
        Object.assign(state.bodyAttributes, attributes);
        break;
      }
      default: {
        const element: HeadElement = { kind, attributes, content };
        state.elements.set(stringifyElement(element), element);
        break;
      }
    }
  }

  return state;
}
